module.exports = __webpack_public_path__ + "static/media/img6.cf04e0d6.jpg";